import { cn } from "@workspace/ui/lib/utils";
import { BadgeCheck, CircleDotDashed, Lock } from "lucide-react";
import { FC, HTMLAttributes } from "react";

type CardStatusProps = HTMLAttributes<HTMLDivElement> & {
  status: "in-progress" | "locked" | "completed";
};

export const CardStatus: FC<CardStatusProps> = ({
  status,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        "z-10 flex items-center gap-1 rounded-full h-5 pl-[3px] pr-[8px]",
        {
          "bg-[#ffdd2c]": status === "in-progress",
          "bg-white": status === "locked",
          "bg-[#EDFFD4]": status === "completed",
        },
        className,
      )}
      {...props}
    >
      {status === "in-progress" && (
        <>
          <CircleDotDashed size={14} />
          <span className="text-xs font-semibold">In progress</span>
        </>
      )}
      {status === "locked" && (
        <>
          <Lock
            size={14}
            className="[&>rect]:fill-[#7c7c7c] stroke-[#7c7c7c]"
          />
          <span className="text-xs font-semibold text-[#7C7C7C]">Locked</span>
        </>
      )}
      {status === "completed" && (
        <>
          <BadgeCheck
            size={14}
            className="[&>path]:first:fill-[#0ea356] [&>path]:first:stroke-[#0ea356] stroke-white"
          />
          <span className="text-xs font-semibold text-[#0ea356]">
            Completed
          </span>
        </>
      )}
    </div>
  );
};
